import { all } from 'redux-saga/effects'
import signupSagas from './signupSagas'
import chatSagas from './chatSagas'
import candidatesSagas from './candidatesSagas'

// @see https://github.com/redux-saga/redux-saga/issues/160
export default function* rootSaga() {
  yield all([
    ...signupSagas,
    ...chatSagas,
    ...candidatesSagas
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/index.js